import React, { ReactNode } from "react";
import Button from "components/button/button";

interface GlimpsePopupProps {
  title?: string;
  popup: boolean;
  children: ReactNode;
  customClass?: string;
  onClose: () => void;
  showCross?: boolean;
  closeText?: string;
}

const GlimpsePopup: React.FC<GlimpsePopupProps> = ({
  title,
  children,
  onClose,
  popup,
  showCross,
  customClass,
  closeText,
}) => {
  return (
    <>
      {popup && (
        <div className="fixed top-0 left-0 h-screen z-50 justify-center items-center w-full md:inset-0  max-h-full bg-[#EEF9FB65] flex">
          <div className="relative max-h-full overflow-auto touch-auto">
            <div
              className={`relative bg-white rounded-lg border border-border shadow w-[630px] p-6 ${customClass}`}
            >
              <div className="flex flex-col h-full gap-4">
                {/* Skip / Close */}
                {showCross && (
                  closeText ? (
                    <div className="flex justify-end shrink-0">
                      <Button variant="outline" onClick={onClose}>
                        {closeText}
                      </Button>
                    </div>
                  ) : (
                    <div className="flex justify-end shrink-0">
                      <button
                        type="button"
                        className="text-text-muted bg-transparent hover:bg-border rounded-full text-sm w-8 h-8 inline-flex justify-center items-center"
                        onClick={onClose}
                      >
                        <svg
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15 5L5 15M5 5L15 15"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="sr-only">Close modal</span>
                      </button>
                    </div>
                  )
                )}
                {/* Main content */}
                <div className="flex flex-col flex-1 min-h-0">
                  {title && (
                    <div className="text-2xl font-semibold text-brand text-center mb-6">
                      {title}
                    </div>
                  )}
                  <div className="text-start flex-1 min-h-0">{children}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GlimpsePopup;
